import { render, staticRenderFns } from "./MerchantTxnsOverview.vue?vue&type=template&id=570a478e&scoped=true"
import script from "./MerchantTxnsOverview.vue?vue&type=script&lang=js"
export * from "./MerchantTxnsOverview.vue?vue&type=script&lang=js"
import style0 from "./MerchantTxnsOverview.vue?vue&type=style&index=0&id=570a478e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a478e",
  null
  
)

export default component.exports